import { useState, useEffect } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  DURU_SCAN_ENABLED: true,
  OCR_ENABLED: true,
  PDF_STUDIO_ENABLED: true,
  DURU_SIGN_ENABLED: true,
  DURU_VERIFY_ENABLED: true,
  DURU_SHIELD_ENABLED: true,
  ADVANCED_SEARCH_ENABLED: true,
  DURUVERIFY_AUTOMATED_ENABLED: false,
  STRIPE_IDENTITY_VERIFICATION_ENABLED: false,
  DURUVERIFY_ADMIN_TEST_ENABLED: false,
  DURUVERIFY_MANUAL_REVIEW_ENABLED: false,
  DURUROOMS_ENABLED: true,
  COMMAND_CENTER_ENABLED: true,
  DURUFLOW_ENABLED: false,
  DURU_TWIN_ENABLED: true,
};

let _cache = null;

// Lightweight app-wide feature-flag hook. Flags are fetched once from /api/features
// and cached in-module; components re-render with the resolved values when ready.
export function useFeatures() {
  const [flags, setFlags] = useState(_cache || DEFAULTS);
  useEffect(() => {
    if (_cache) { setFlags(_cache); return; }
    api.get("/features").then(({ data }) => { _cache = data; setFlags(data); }).catch(() => {});
  }, []);
  return flags;
}

export function clearFeaturesCache() { _cache = null; }
